import * as Schema from "effect/Schema";

import { TrimmedNonEmptyString } from "./baseSchemas.ts";

/**
 * AgentCore hosts the same environment server as local Fabrica. Cloud control
 * returns lifecycle and guided Fabrica Connect state only; AWS credentials and
 * the environment's stored Connect credential never cross this contract.
 */
export const CloudEnvironmentRuntimeStatus = Schema.Literals([
  "started",
  "running",
  "restarted",
  "stopped",
]);
export type CloudEnvironmentRuntimeStatus = typeof CloudEnvironmentRuntimeStatus.Type;

export const CloudEnvironmentControlResult = Schema.Union([
  Schema.Struct({
    state: Schema.Literal("unavailable"),
    reason: Schema.Literal("not_configured"),
    message: TrimmedNonEmptyString,
  }),
  Schema.Struct({
    state: Schema.Literal("needs_connect_authorization"),
    placement: Schema.Literal("cloud"),
    runtimeStatus: CloudEnvironmentRuntimeStatus,
    authorizeUrl: TrimmedNonEmptyString.check(Schema.isMaxLength(8_192)),
  }),
  Schema.Struct({
    state: Schema.Literal("connecting"),
    placement: Schema.Literal("cloud"),
    runtimeStatus: CloudEnvironmentRuntimeStatus,
  }),
  Schema.Struct({
    state: Schema.Literal("ready"),
    placement: Schema.Literal("cloud"),
    runtimeStatus: CloudEnvironmentRuntimeStatus,
  }),
  Schema.Struct({
    state: Schema.Literal("stopped"),
    placement: Schema.Literal("cloud"),
    runtimeStatus: Schema.Literal("stopped"),
  }),
]);
export type CloudEnvironmentControlResult = typeof CloudEnvironmentControlResult.Type;

/** A short-lived, PKCE-bound code from the existing headless Connect flow. */
export const CloudEnvironmentConnectAuthorizationRequest = Schema.Struct({
  authorizationCode: TrimmedNonEmptyString.check(Schema.isMaxLength(16_384)),
});
export type CloudEnvironmentConnectAuthorizationRequest =
  typeof CloudEnvironmentConnectAuthorizationRequest.Type;
